var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalboxLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 17,
    viewBox: "0 0 74 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6181 16.4358C31.8584 16.3257 31.107 16.0446 30.5596 15.6658C30.3569 15.5255 30.1778 15.3774 30.1777 15.35C30.1777 15.3331 30.7916 14.5652 30.9117 14.432C30.9157 14.4276 30.9962 14.4965 31.0906 14.5853C31.8229 15.2742 32.9224 15.5796 33.926 15.3728C34.5298 15.2484 34.9962 14.8975 35.2505 14.3765C35.4434 13.9811 35.5012 13.6589 35.5191 12.8781C35.532 12.3203 35.5252 12.2225 35.4739 12.2225C35.4576 12.2225 35.3961 12.2831 35.3372 12.3571C34.9488 12.8452 34.4112 13.1467 33.718 13.2649C33.4988 13.3023 33.3996 13.3079 33.1062 13.2989C32.9136 13.293 32.6724 13.2728 32.5702 13.2539C31.4557 13.0485 30.5814 12.287 30.2226 11.2092C30.0854 10.7971 30.0618 10.6302 30.0613 10.0685C30.0609 9.61453 30.0663 9.53411 30.1103 9.32834C30.3977 7.98544 31.3358 7.05009 32.6149 6.831C32.9192 6.77889 33.4161 6.77536 33.702 6.82327C33.9352 6.86235 34.3375 6.99079 34.5309 7.08792C34.8634 7.25486 35.1878 7.53347 35.3777 7.81502C35.5382 8.05306 35.545 8.03927 35.5516 7.46354L35.5573 6.97013L36.1356 6.96449L36.7139 6.95884V10.0963C36.7139 12.1524 36.7062 13.3137 36.6914 13.4656C36.5628 14.7863 36.0227 15.6303 34.9867 16.129C34.7045 16.2648 34.4734 16.3384 34.1157 16.4062C33.8106 16.464 32.9326 16.4813 32.6181 16.4358ZM33.9975 12.2374C35.0104 11.9702 35.6516 11.0535 35.6035 9.94119C35.5803 9.40441 35.417 8.95784 35.1 8.5645C34.8236 8.22147 34.3714 7.93218 33.9445 7.82515C33.6775 7.75824 33.1148 7.75824 32.8691 7.82516C32.1499 8.02098 31.6316 8.50408 31.4014 9.19307C31.1955 9.80951 31.2295 10.5293 31.4911 11.0874C31.7831 11.7105 32.3446 12.1512 33.0074 12.2774C33.2504 12.3236 33.7464 12.3036 33.9975 12.2374ZM23.3866 13.4722C22.5823 13.3804 21.7913 13.0662 21.2539 12.6252C21.0536 12.4608 20.7926 12.188 20.8012 12.152C20.8051 12.1359 21.004 11.9576 21.2432 11.7557C21.4825 11.5538 21.6957 11.3736 21.717 11.3552C21.7531 11.324 21.7609 11.3282 21.8319 11.4167C22.156 11.8209 22.6831 12.179 23.1532 12.3143C23.7772 12.4939 24.5064 12.4238 25.012 12.1355C25.3156 11.9624 25.6065 11.6413 25.7217 11.352C25.8684 10.9836 25.8554 10.463 25.6912 10.1329C25.5339 9.81679 25.274 9.58284 24.8403 9.36712C24.6308 9.26289 24.3807 9.16917 23.8005 8.97753C22.9616 8.70045 22.7916 8.637 22.5066 8.49457C22.2155 8.34907 21.9735 8.17923 21.7718 7.97891C21.3663 7.57609 21.168 7.13661 21.1129 6.51871C21.0543 5.86082 21.2109 5.24789 21.5565 4.78248C22.0916 4.06179 22.925 3.66205 24.0515 3.58568C25.0813 3.51587 26.1432 3.83965 26.8041 4.42493C27.037 4.63118 27.0519 4.58189 26.6299 4.9998C26.4276 5.20003 26.2304 5.39009 26.1916 5.42215L26.1211 5.48045L25.9867 5.34204C25.5295 4.87112 24.9402 4.62548 24.2674 4.62534C23.8277 4.62526 23.3329 4.76415 23.0377 4.97054C22.7896 5.14402 22.5303 5.47742 22.45 5.72605C22.3874 5.92 22.3715 6.33881 22.419 6.54175C22.5024 6.89764 22.7193 7.17257 23.0977 7.4018C23.2953 7.52156 23.5818 7.63407 24.278 7.86539C25.0757 8.13045 25.4636 8.27346 25.6786 8.3817C26.0684 8.57798 26.4493 8.88474 26.6783 9.18673C26.8167 9.36929 26.9831 9.70873 27.0356 9.91565C27.1338 10.3022 27.1437 10.8312 27.0608 11.2581C26.9038 12.066 26.4136 12.7054 25.656 13.0905C25.0183 13.4147 24.155 13.5599 23.3866 13.4722ZM56.7367 13.4188C56.1295 13.3529 55.5328 13.0912 55.1276 12.713C55.0699 12.6592 54.9611 12.5363 54.8858 12.4401C54.7494 12.2655 54.7049 12.2349 54.6804 12.2985C54.6733 12.317 54.6675 12.5414 54.6675 12.7973V13.2624H54.0946H53.5216V8.21128V3.16016L54.1105 3.16579L54.6994 3.17143L54.71 5.52705C54.7205 7.8683 54.7209 7.88271 54.7634 7.8888C54.7935 7.89313 54.8301 7.86353 54.8873 7.78853C55.0846 7.52983 55.483 7.20902 55.81 7.04553C55.9714 6.96484 56.2571 6.87014 56.4608 6.82979C56.6924 6.7839 57.4713 6.78957 57.7023 6.83882C58.3413 6.97508 58.8552 7.2574 59.2878 7.70993C59.878 8.32729 60.1862 9.14836 60.1848 10.0998C60.1833 10.998 59.8973 11.8046 59.3602 12.4234C58.9397 12.9079 58.2979 13.2622 57.628 13.3797C57.4387 13.4129 56.8999 13.4366 56.7367 13.4188ZM57.1639 12.4053C57.8895 12.2964 58.4886 11.8191 58.7644 11.1304C58.8955 10.8028 58.9371 10.592 58.9485 10.1958C58.9607 9.77258 58.9321 9.5628 58.8128 9.2037C58.6322 8.66015 58.2645 8.22925 57.7765 7.98925C57.4586 7.83288 57.2924 7.7993 56.8322 7.79848C56.4881 7.79788 56.4177 7.80376 56.2627 7.84616C55.452 8.06782 54.8482 8.7536 54.6757 9.64886C54.6282 9.89528 54.6282 10.3266 54.6757 10.5731C54.9152 11.8155 55.9614 12.5859 57.1639 12.4053ZM63.5938 13.4089C63.1821 13.3655 62.7833 13.2548 62.4228 13.0841C61.5222 12.6575 60.8938 11.8444 60.6686 10.8144C60.6273 10.6253 60.6215 10.537 60.6215 10.0897C60.6215 9.64298 60.6272 9.55498 60.668 9.37332C60.9208 8.2462 61.626 7.42058 62.6828 7.01436C63.1289 6.84286 63.5531 6.77885 64.1283 6.79623C64.813 6.81692 65.333 6.96559 65.8784 7.29661C67.0533 8.00979 67.628 9.43608 67.3164 10.8661C66.9538 12.5308 65.3908 13.5984 63.5938 13.4089ZM64.3447 12.4037C64.9339 12.3138 65.4121 12.0068 65.7395 11.5081C66.426 10.4627 66.2143 8.90448 65.2909 8.20733C65.0849 8.0518 64.7992 7.90998 64.5675 7.84833C64.3258 7.78398 63.8127 7.76883 63.5494 7.81825C63.3148 7.86229 63.0925 7.94663 62.8698 8.07608C62.6406 8.20931 62.3124 8.54033 62.1778 8.77399C61.6506 9.68946 61.7266 10.8934 62.3616 11.6871C62.8159 12.2548 63.5595 12.5236 64.3447 12.4037ZM46.0834 13.3814C45.2784 13.2486 44.7355 12.8971 44.4454 12.3209C44.3142 12.0604 44.2827 11.8997 44.2827 11.4904C44.2827 11.1872 44.29 11.1032 44.3282 10.9644C44.4886 10.3814 44.9734 9.94775 45.7434 9.69852C46.3737 9.49451 46.9989 9.41158 48.1065 9.3851C48.5502 9.37449 48.6498 9.36653 48.6768 9.33956C48.7041 9.31226 48.707 9.27034 48.6946 9.08526C48.6667 8.66744 48.5633 8.39715 48.3489 8.18101C48.0566 7.88643 47.6482 7.74473 47.0914 7.74473C46.4747 7.74473 45.8866 7.95838 45.4046 8.35751C45.3465 8.40566 45.2924 8.44505 45.2844 8.44505C45.2623 8.44505 44.6721 7.73117 44.6721 7.70446C44.6721 7.66483 45.0009 7.41878 45.2185 7.29556C45.5989 7.08018 45.9604 6.94711 46.4245 6.8516C46.7315 6.78842 47.4384 6.77165 47.7655 6.81979C48.3599 6.90726 48.8316 7.12622 49.1833 7.47792C49.5033 7.79801 49.6932 8.18124 49.799 8.72093C49.8297 8.87739 49.8366 9.16734 49.851 10.9068C49.8609 12.0997 49.8763 12.9595 49.8892 13.029C49.9011 13.0932 49.9115 13.1719 49.9123 13.204L49.9138 13.2624H49.3965C49.0083 13.2624 48.8737 13.2558 48.8574 13.2359C48.8295 13.2017 48.7741 12.8442 48.7552 12.5762C48.7372 12.3207 48.7111 12.297 48.6012 12.4363C48.5604 12.488 48.4303 12.6257 48.312 12.7425C47.9916 13.0587 47.6477 13.2465 47.1988 13.3505C46.9623 13.4053 46.3335 13.4227 46.0834 13.3814ZM47.2708 12.4449C47.9955 12.3186 48.5245 11.7697 48.6611 11.0023C48.6927 10.8245 48.7134 10.3999 48.6951 10.3027L48.68 10.2217L48.082 10.2337C47.0594 10.2543 46.442 10.3673 46.0303 10.6092C45.6554 10.8295 45.4998 11.0824 45.4998 11.4708C45.4998 11.9737 45.8271 12.3316 46.3911 12.4454C46.5839 12.4843 47.0466 12.484 47.2708 12.4449ZM28.0017 13.2362C27.9961 13.2214 27.9939 11.8055 27.9969 10.0897L28.0024 6.97014L28.602 6.9645L29.2015 6.95887L29.1962 10.1053L29.1908 13.2518L28.6013 13.2574C28.1412 13.2618 28.0097 13.2572 28.0017 13.2362ZM37.9342 13.2362C37.9289 13.2214 37.9206 11.8389 37.9158 10.164C37.9109 8.48908 37.9001 7.08288 37.8917 7.03911L37.8765 6.95953H38.4399C38.7498 6.95953 39.0081 6.96719 39.0139 6.97656C39.0197 6.98592 39.0353 7.21273 39.0486 7.48057C39.0619 7.74841 39.08 7.97504 39.0888 7.98417C39.1202 8.01655 39.166 7.9748 39.2393 7.84699C39.4594 7.46351 39.8998 7.10684 40.3726 6.92917C40.836 6.755 41.5445 6.74121 42.0185 6.89714C42.7774 7.14678 43.2997 7.75822 43.4714 8.59795C43.543 8.94782 43.5489 9.16352 43.5428 11.2145L43.5367 13.2518L42.9496 13.2574L42.3625 13.2631L42.3528 11.3156C42.3462 10.0086 42.335 9.31238 42.3186 9.19843C42.2587 8.78246 42.134 8.45585 41.9485 8.22919C41.8223 8.07498 41.572 7.90734 41.3758 7.84567C41.243 7.80392 41.1787 7.79787 40.8734 7.7984C40.5502 7.79896 40.5102 7.80344 40.3535 7.85622C40.2601 7.88768 40.1221 7.94948 40.0468 7.99355C39.6934 8.20046 39.3727 8.62436 39.2499 9.04686C39.1426 9.41584 39.147 9.32803 39.1344 11.3524L39.1226 13.2518L38.5332 13.2574C38.0728 13.2618 37.9416 13.2572 37.9342 13.2362ZM51.0386 8.21161V3.16016L51.6275 3.16579L52.2164 3.17143V8.21161V13.2518L51.6275 13.2574L51.0386 13.2631V8.21161ZM67.2524 13.2465C67.2526 13.2377 67.8109 12.5 68.4931 11.6071C69.1753 10.7142 69.7338 9.96687 69.7342 9.94637C69.7347 9.92588 69.2289 9.25119 68.6103 8.44705C67.9916 7.6429 67.4855 6.97912 67.4855 6.97197C67.4855 6.96483 67.8161 6.96149 68.2201 6.96456L68.9547 6.97013L69.6949 8.01C70.102 8.58193 70.45 9.06722 70.4681 9.08843C70.4862 9.10964 70.5125 9.12325 70.5266 9.11867C70.5406 9.11408 70.8997 8.6264 71.3246 8.03493L72.0972 6.95953H72.7969C73.3534 6.95953 73.4923 6.96495 73.4758 6.98605C72.8968 7.73067 71.2539 9.90784 71.254 9.93054C71.254 9.94807 71.8101 10.6903 72.4898 11.5799C73.1695 12.4695 73.7312 13.2122 73.7381 13.2302C73.7494 13.2594 73.6707 13.2623 73.0116 13.2574L72.2725 13.2518L71.4011 12.0315C70.7579 11.1308 70.5189 10.8113 70.4882 10.8113C70.4576 10.8113 70.2143 11.1319 69.5716 12.0192C69.0903 12.6836 68.6843 13.235 68.6693 13.2445C68.6351 13.2662 67.252 13.2681 67.2524 13.2465ZM28.4162 5.38132C28.1683 5.32723 27.9778 5.17533 27.8671 4.94346C27.819 4.84276 27.8114 4.79899 27.8114 4.62468C27.8114 4.43961 27.8172 4.41086 27.8804 4.28253C27.9622 4.1163 28.0955 3.98587 28.2639 3.90721C28.3685 3.85839 28.411 3.85112 28.586 3.85208C28.8382 3.85344 28.9743 3.90246 29.1427 4.05258C29.3144 4.20559 29.3779 4.34508 29.3883 4.59211C29.395 4.75052 29.3885 4.80556 29.3508 4.90529C29.2615 5.14238 29.0165 5.33783 28.7466 5.38727C28.596 5.41484 28.5676 5.41433 28.4162 5.38132Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "white",
    fillOpacity: 0.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3335,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99976,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99976,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99976,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99976,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3335,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99976,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99976,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3335,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3335,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6663,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6663,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6663,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6663,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6663,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6663,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33325,
    y: 3.16406,
    width: 2.66664,
    height: 2.66664,
    fill: "white",
    fillOpacity: 0.9
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33325,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "white",
    fillOpacity: 0.9
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 2.66675,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalboxLogoLight);
export default __webpack_public_path__ + "static/media/signalbox_logo_light.71ea3ddce198d852ff43b12745a8c338.svg";
export { ForwardRef as ReactComponent };